import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import { useLocation } from 'react-router';
import DatePicker from 'react-datepicker';
import './style.css'
import { toast } from 'react-toastify';
import { getFormattedDate } from '../../../common/date';
import LenderUgroService from '../../../services/lender';
import MasterDataService from '../../../services/master-data';
import { objectsForEach } from '../../../common/objectToArray';

import { Context } from '../../../config/store';
import { downloadFile } from '../../../common/download';
import Select from '../../../components/Field/Select';
import ReactTooltip from 'react-tooltip';

export default function QueryMis() {
  const location = useLocation()
  const { state } = useContext(Context);

  const [title, setTitle] = useState('')
  const [tableLoader, setTableLoader] = useState(false)
  const [submitLoader, setSubmitLoader] = useState(false)
  const [qLoader, setQLoader] = useState(true)
  const [dLoader, setDLoader] = useState(true)
  const [cLoader, setCLoader] = useState(true)
  const [clloader, setClLoader] = useState(true)
  const [utrLoader, setUtrLoader] = useState(true)
  const [lenderLoader, setLenderLoader] = useState(true)
  const [downloadFromDate, setDownloadFromDate] = useState('')
  const [downloadToDate, setDownloadToDate] = useState('')
  const [endPoint, setEndPoint] = useState('')
  const [queryList, setQueryList] = useState([])
  const [documentList, setDocumentList] = useState([])
  const [consolidateList, setConsolidateList] = useState([])
  const [breList, setbreList] = useState([])
  const [colendingList, setColendingList] = useState([])
  const [utrList, setUtrList] = useState([])
  const [lenderDataList, setLenderDataList] = useState([])
  const [lenderList, SetlenderList] = React.useState([]);
  const [ElegibleLender, setElegibleLender] = useState('')
  const [permission, setPermission] = useState('')
  const [assignDatefrom, setAssignDatefrom] = useState('')
  const [assignDateto, setAssignDateto] = useState('')
  const [lenderDatefrom, setLenderDatefrom] = useState('')
  const [lenderDateto, setLenderDateto] = useState('')
  const [assignlender, setassignlender] = React.useState('');
  const [selectlender, Setselectlender] = useState('')
  const [programName, setProgramName] = useState('')
  const [showError, setShowError] = useState(false);


  let heading = location.pathname.split('/')[2]

  useEffect(async () => {
    setTitle(heading)
    setDownloadFromDate('')
    setDownloadToDate('')
    setElegibleLender('')
    setAssignDatefrom('')
    setAssignDateto('')
    Setselectlender('')
    setShowError(false)

    if (heading === 'query') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Mis Report`)
      setPermission('submit-query-mis-reports')
      setEndPoint('query-mis')
      await getDownloadsHistory('query-mis/list')
    } else if (heading === 'document') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Availibility Mis Report`)
      setPermission('submit-documents-availability-mis')
      setEndPoint('documents-availability-mis')
      await getDownloadsHistory('documents-availability-mis/list')
    } else if (heading === 'consolidate') {
      setTitle(`Portfolio Mis Report`)
      setPermission('submit-consolidate-mis')
      setEndPoint('consolidate-mis')
      await getDownloadsHistory('consolidate-mis/list')
    }
    else if (heading === 'bre') {
      setTitle(`${heading.toUpperCase()}  Report`)
      setPermission('submit-bre-report')
      setEndPoint('bre')
      await getDownloadsHistory('bre/list')
    }
    else if (heading === 'colending') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Mis Report`)
      setPermission('submit-colending-mis')
      setEndPoint('colending')
      await getDownloadsHistory('colending/list')
    }
    else if (heading === 'utr') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Mis Report`)
      setPermission('submit-utr-report')
      setEndPoint('utr')
      await getDownloadsHistory('utr/list')
    }
    else if (heading === 'lender') {
      setTitle(`${heading.charAt(0).toUpperCase() + heading.substring(1)} Mis Report`)
      setPermission('submit-lender-mis-report')
      setEndPoint('lender-mis')
      await getDownloadsHistory('lender-mis/list')
    }
  }, [heading])

  const getDownloadsHistory = async (endPoint) => {
    let response = null;
    response = await LenderUgroService.getDownloadsHistory({
      type: state.userType,
      endPoint
    });
    if (heading === 'query') {
      setQueryList(response?.data?.data?.query_reports)
      setQLoader(false)
    } else if (heading === 'document') {
      setDocumentList(response?.data?.data?.document_reports)
      setDLoader(false)
    } else if (heading === 'consolidate') {
      setConsolidateList(response?.data?.data?.consolidate_reports)
      setCLoader(false)
    } else if (heading === 'bre') {
      setbreList(response?.data?.data?.query_reports)
      setQLoader(false)
    } else if (heading === 'colending') {
      setColendingList(response?.data?.data?.query_reports)
      setClLoader(false)
    } else if (heading === 'utr') {
      setUtrList(response?.data?.data?.utr_reports)
      setUtrLoader(false)
    } else if (heading === 'lender') {
      setLenderDataList(response?.data?.data?.lender_mis_reports)
      setLenderLoader(false)
    }
  }

  const handleSubmit = async () => {
    if (downloadFromDate === '') {
      toast.error('Please select From date')
      return;
    }
    if (downloadToDate === '') {
      toast.error('Please select To date')
      return;
    }
    let startDate = getFormattedDate(downloadFromDate)
    let endDate = getFormattedDate(downloadToDate)

    if (downloadFromDate <= downloadToDate) {
      setSubmitLoader(true)
      await handleFilterMisReport(startDate, endDate)
      setSubmitLoader(false)
      setDownloadFromDate('')
      setDownloadToDate('')
      setElegibleLender('')
      setAssignDatefrom('')
      setAssignDateto('')
      setassignlender('')
      Setselectlender('')
    } else {
      toast.error("From date should be lesser than To date")
      return;
    }
  }

  const handleLenderMisReport = async () => {
    if (!selectlender) {
      return toast.error("Please select Lender");
    }
    if (!programName) {
      return toast.error("Please select Program name");
    }
    if ((lenderDatefrom && !lenderDateto) || (!lenderDatefrom && lenderDateto)) {
      return toast.error("Please select from date and to date")
    }

    if (lenderDatefrom <= lenderDateto) {
      let payloadData = {
        assignLender: selectlender,
        prod_cat: programName,  //(required)
        assigned_date_from: lenderDatefrom ? getFormattedDate(lenderDatefrom, 'dd/MM/yyyy') : '',
        assigned_date_to: lenderDateto ? getFormattedDate(lenderDateto, 'dd/MM/yyyy') : ''
      }
      let response = null;
      let toastId = null;
      try {
        setSubmitLoader(true)
        response = await LenderUgroService.downloadMisReportNew({
          type: state.userType,
          dataExport: 1,
          responseType: "blob",
          endPoint,
          payloadData
        });
        toastId = toast.success(response?.data?.messages?.success?.others[0])
        let toastInfo = response?.data?.messages?.error?.others.join()
        if (toastInfo.length > 0) {
          toast.info(toastInfo)
        }
        Setselectlender('')
        setProgramName('')
        setLenderDatefrom('')
        setLenderDateto('')
        setSubmitLoader(false)
        setTimeout(async () => {
          await getDownloadsHistory('lender-mis/list')
        }, 2000);
      } catch (error) {
        toast.dismiss(toastId)
        toast.error(error.message)
        setTableLoader(false)
        setSubmitLoader(false)
      }
    } else {
      toast.error("From date should be lesser than To date")
      return;
    }
  }

  const handleFilterMisReport = async (startDate, endDate) => {
    let payloadData = {
      "from_date": startDate ? startDate : '',
      "to_date": endDate ? endDate : '',
      'eligibleLender': ElegibleLender ? ElegibleLender : '',
      "assigned_date_from": assignDatefrom ? getFormattedDate(assignDatefrom, 'dd/MM/yyyy') : '',
      "assigned_date_to": assignDateto ? getFormattedDate(assignDateto, 'dd/MM/yyyy') : '',
      'assignLender': assignlender ? assignlender : '',
      'lenderId': selectlender
    }
    Setselectlender('')
    let response = null;
    let toastId = null;
    try {
      setSubmitLoader(true)
      response = await LenderUgroService.downloadMisReportNew({
        type: state.userType,
        dataExport: 1,
        responseType: "blob",
        endPoint,
        payloadData
      });
      toastId = toast.success(response?.data?.messages?.success?.others[0])
      let toastInfo = response?.data?.messages?.error?.others.join()
      if (toastInfo.length > 0) {
        toast.info(toastInfo)
      }
      setSubmitLoader(false)
      setTimeout(async () => {
        if (heading === 'query') {
          await getDownloadsHistory('query-mis/list')
        } else if (heading === 'document') {
          await getDownloadsHistory('documents-availability-mis/list')
        } else if (heading === 'consolidate') {
          await getDownloadsHistory('consolidate-mis/list')
        } else if (heading === 'bre') {
          await getDownloadsHistory('bre/list')
        } else if (heading === 'colending') {
          await getDownloadsHistory('colending/list')
        } else if (heading === 'utr') {
          await getDownloadsHistory('utr/list')
        } else if (heading === 'lender') {
          await getDownloadsHistory('lender-mis/list')
        }
      }, 2000);
    } catch (error) {
      toast.dismiss(toastId)
      toast.error(error.message)
      setTableLoader(false)
      setSubmitLoader(false)
    }
  }

  const handleReportDownload = async (fileName, fileId) => {

    let response = null;
    let toastId = toast.warning("Download started, Please wait...")
    try {
      response = await LenderUgroService.downloadFileById({
        type: state.userType,
        fileId,
        responseType: 'blob'
      });
      toast.dismiss(toastId)
      downloadFile(response?.data, fileName)
    } catch (error) {
      toast.dismiss(toastId)
      toast.error(error.message)
    }
  }

  const handleRefresh = async () => {
    setTableLoader(true)
    if (heading === 'query') {
      await getDownloadsHistory('query-mis/list')
      setTableLoader(false)
    } else if (heading === 'document') {
      await getDownloadsHistory('documents-availability-mis/list')
      setTableLoader(false)
    } else if (heading === 'consolidate') {
      await getDownloadsHistory('consolidate-mis/list')
      setTableLoader(false)
    } else if (heading === 'bre') {
      await getDownloadsHistory('bre/list')
      setTableLoader(false)
    } else if (heading === 'colending') {
      await getDownloadsHistory('colending/list')
      setTableLoader(false)
    } else if (heading === 'utr') {
      await getDownloadsHistory('utr/list')
      setTableLoader(false)
    } else if (heading === 'lender') {
      await getDownloadsHistory('lender-mis/list')
      setTableLoader(false)
    }
  }

  const getlenders = async () => {
    const response = await MasterDataService.getLenderList(
      state.userType,
      'co-lender',
    );

    let responseList = objectsForEach(
      response.data.data.lender_list,
      'STRING_VAL'
    );
    SetlenderList(responseList);
  };

  React.useEffect(() => {
    getlenders();
  }, []);

  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  const resetFilter = () => {
    setDownloadFromDate('')
    setDownloadToDate('')
    setElegibleLender('')
    setAssignDatefrom('')
    setAssignDateto('')
    setassignlender('')
    Setselectlender('')
    setShowError(false)
    setProgramName('')
    setLenderDatefrom('')
    setLenderDateto('')
    // getApiLogsList(false)
  }

  return (
    <div class="portfolio-dashboard">
      <div class="chart-card h-100">
        <div className='d-flex'>
          <h3 className='topTitle'>{title}</h3>
        </div>
        <div className='form-group'>
          <div className='d-flex align-items-end datepicker'>
            {/* {console.log('dffghjk', permission)} */}
            {checkHasPermission(permission) && <>
              {(heading != 'colending' && heading != 'lender') && <>
                <div className='datepicker'>
                  <label className='datepickerLabel mr-1'>From Date <tt>*</tt></label>
                  <div>
                    <DatePicker
                      selected={downloadFromDate}
                      portalId='datepickerportal'
                      showMonthDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      className='form-control'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) => {
                        setDownloadFromDate(selectedDate)
                      }} //only when value has changed
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel mr-1'>To Date <tt>*</tt></label>
                  <div>
                    <DatePicker
                      selected={downloadToDate}
                      portalId='datepickerportal'
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showMonthDropdown
                      className='form-control'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) => {
                        setDownloadToDate(selectedDate)
                      }} //only when value has changed
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              </>}
              {(heading === 'query') && <>
                <div className='datepicker'>
                  <label className='datepickerLabel'>Case Assign Date from</label>
                  <div>
                    <DatePicker
                      selected={assignDatefrom}
                      portalId='datepickerportal'
                      showMonthDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      className='form-control'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) =>
                        setAssignDatefrom(selectedDate)
                      } //only when value has changed
                    />
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel'>Case Assign Date to</label>
                  <div>
                    <DatePicker
                      selected={assignDateto}
                      portalId='datepickerportal'
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showMonthDropdown
                      className='form-control'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) =>
                        setAssignDateto(selectedDate)
                      } //only when value has changed
                    />
                  </div>
                </div>
              </>}
              {heading != 'lender' && heading !== 'query' && heading !== 'colending' && heading !== 'utr' && <div className="datepicker">
                <label className='datepickerLabel'>Eligible Lender</label>
                <div>
                  <select className='form-control'
                    onChange={(e) => setElegibleLender(e.target.value)}
                    value={ElegibleLender}>
                    <option >All</option>
                    {(lenderList.length ? lenderList : lenderList).map(
                      (lenderList, i) => {
                        return (
                          <option value={lenderList.id}>{lenderList.value}</option>
                        );
                      }
                    )}
                  </select>
                </div>
              </div>}
              {['colending', 'utr'].includes(heading) && checkHasPermission(permission) && <div className="datepicker">
                <label className='datepickerLabel'>Select Lender {heading === 'colending' && <tt>*</tt>}</label>
                <div>
                  <select className='form-control'
                    onChange={(e) => {
                      Setselectlender(e.target.value);
                      (heading === 'colending' && (e.target.value == '' || e.target.value == 'Select Lender')) ? setShowError(true) : setShowError(false);
                    }}
                    value={selectlender}>
                    <option >{heading === 'colending' ? 'Select Lender' : 'All'}</option>
                    {(lenderList.length ? lenderList : lenderList).map(
                      (lenderList, i) => {
                        return (
                          <option value={lenderList.id}>{lenderList.value}</option>
                        );
                      }
                    )}
                  </select>
                </div>
              </div>}
              <div>
              </div>
            </>}
            {heading === 'query' && <div className="datepicker">
              <label className='datepickerLabel'>Assign Lender</label>
              <div>
                <select className='form-control'
                  onChange={(e) => setassignlender(e.target.value)}
                  value={assignlender}>
                  <option > All </option>
                  {(lenderList.length ? lenderList : lenderList).map(
                    (lenderList, i) => {
                      return (
                        <option value={lenderList.id}>{lenderList.value}</option>
                      );
                    }
                  )}
                </select>
              </div>
            </div>}
            {heading === 'lender' && checkHasPermission(permission) &&
              <>
                <div className='datepicker'>
                  <label className='datepickerLabel'>Case Assign Date from</label>
                  <div>
                    <DatePicker
                      selected={lenderDatefrom}
                      portalId='datepickerportal'
                      showMonthDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      className='form-control'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) =>
                        setLenderDatefrom(selectedDate)
                      } //only when value has changed
                    />
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel'>Case Assign Date to</label>
                  <div>
                    <DatePicker
                      selected={lenderDateto}
                      portalId='datepickerportal'
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showMonthDropdown
                      className='form-control'
                      dateFormat='dd/MM/yyyy'
                      onChange={(selectedDate) =>
                        setLenderDateto(selectedDate)
                      } //only when value has changed
                    />
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel'>Select Lender <tt>*</tt></label>
                  <div>
                    <select className='form-control'
                      onChange={(e) => {
                        Setselectlender(e.target.value);
                      }}
                      value={selectlender}>
                      <option value={''} >{'Select Lender'}</option>
                      <option value={'8'}>{'MAS Financial Services'}</option>
                      <option value={'17'}>{'TATA Capital'}</option>
                      <option value={'21'}>{'Mahindra Finance'}</option>
                    </select>
                  </div>
                </div>
                <div className="datepicker">
                  <label className='datepickerLabel'>Program Name <tt>*</tt></label>
                  <div>
                    <select className='form-control'
                      onChange={(e) => {
                        setProgramName(e.target.value);
                      }}
                      value={programName}>
                      <option >{'Select Program'}</option>
                      <option value={'2'}>{'Secured'}</option>
                      <option value={'3'}>{'Unsecured'}</option>
                      <option value={'5'}>{'Secured - Plant & Machinery'}</option>
                      <option value={'6'}>{'Secured - GRO Micro'}</option>
                      <option value={'7'}>{'Unsecured - GRO Micro'}</option>
                    </select>
                  </div>
                </div>
              </>
            }
          </div>
          {(showError && heading === 'colending') &&
            <p className='ml-1 mt-0 mb-0 text-danger'>
              Please select lender
            </p>}
          {checkHasPermission(permission) && <div>
            <div className='row'>
              <div className='col-md-12 d-flex p-2'>
                {/* {<br></br>} */}
                <button
                  className='btn btn-custom submitBtn m-1'
                  disabled={submitLoader}
                  // onClick={() => { handleSubmit() }} handleFilterMisReport
                  onClick={() => {
                    if (heading === 'colending') {
                      if (selectlender == '' || selectlender == 'Select Lender') {
                        setShowError(true);
                      } else {
                        handleFilterMisReport();
                      }
                    } else if (heading === 'lender') {
                      handleLenderMisReport();
                    } else {
                      handleSubmit();
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {submitLoader ? <div className="loader"></div> : 'Search'}
                </button>
                <button
                  onClick={resetFilter}
                  type='button'
                  className='btn btn-custom submitBtn m-1'
                >
                  Reset All
                </button>
              </div>
            </div>
          </div>}
          {/* <div className='mt-4'> */}
          <div className="row justify-content-between m-1 mb-2 align-items-center">
            <h3 className='DownloadTitle mb-0'>Downloads History</h3>
            <button
              className='btn btn-custom submitBtn'
              onClick={() => { handleRefresh() }}
              disabled={tableLoader}
              // onClick={() => { handleFilterMisReport() }}
              style={{ cursor: 'pointer' }}
            >

              {tableLoader ? <div className="loader"></div> : <span><i class="fa fa-refresh mr-1" aria-hidden="true"></i> Refresh </span>}
            </button>
          </div>
          <div className={heading != 'colending' ? 'misReports' : 'misColending'}>
            <table className="table" style={{ border: 1, borderColor: '#dee2e6', borderStyle: 'solid', textAlign: 'center' }}>
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ width: "10%" }}>S No.</th>
                  {(heading != 'colending' && heading != 'lender') && <th scope="col" style={{ width: "150px" }}>From Date</th>}
                  {(heading != 'colending' && heading != 'lender') && <th scope="col" style={{ width: "150px" }}>To Date</th>}
                  {(heading == 'lender') && <th scope="col" style={{ width: "150px" }}>Case Assign Date from</th>}
                  {(heading == 'lender') && <th scope="col" style={{ width: "150px" }}>Case Assign Date To</th>}
                  <th scope="col" style={{ width: "150px" }}>Created at</th>
                  <th scope="col" style={heading == 'colending' ? { width: "350px" } : {}}>File Name</th>
                  <th scope="col" style={{ width: "130px" }}>Created by</th>
                  <th scope="col" style={{ width: "130px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {heading === 'query' ?
                  qLoader ?
                    <div className='MisLoaderContainer'>
                      <div className="loader" style={{ margin: "10% auto auto" }}></div>
                    </div>
                    :
                    queryList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr key={item?.report_id}>
                          <td>{index + 1}</td>
                          <td>{parsedData?.from_date}</td>
                          <td>{parsedData?.to_date}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>
                          </td>
                        </tr>
                      )
                    }) : null}
                {heading === 'bre' ?
                  qLoader ?
                    <div className='MisLoaderContainer'>
                      <div className="loader" style={{ margin: "10% auto auto" }}></div>
                    </div>
                    :
                    breList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr key={item?.report_id}>
                          <td>{index + 1}</td>
                          <td>{parsedData?.from_date}</td>
                          <td>{parsedData?.to_date}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>
                            {/* <button
                              className='btn btn-custom submitBtn'
                              
                            >
                              Download
                            </button> */}
                          </td>
                        </tr>
                      )
                    }) : null}

                {heading === 'document' ?
                  dLoader ?
                    <div className="MisLoaderContainer">
                      <div className="loader"></div>
                    </div>
                    :
                    documentList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{parsedData?.from_date}</td>
                          <td>{parsedData?.to_date}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>

                          </td>
                        </tr>
                      )
                    }) : null}
                {heading === 'consolidate' ?
                  cLoader ?
                    <div className="MisLoaderContainer">
                      <div className="loader"></div>
                    </div>
                    :
                    consolidateList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{parsedData?.from_date}</td>
                          <td>{parsedData?.to_date}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>

                          </td>
                        </tr>
                      )
                    }) : null}
                {heading === 'colending' ?
                  clloader ?
                    <div className="MisLoaderContainer">
                      <div className="loader"></div>
                    </div>
                    :
                    colendingList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          {/* <td>{parsedData?.from_date}</td>
                          <td>{parsedData?.to_date}</td> */}
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>

                          </td>
                        </tr>
                      )
                    }) : null}
                {heading === 'utr' ?
                  utrLoader ?
                    <div className='MisLoaderContainer'>
                      <div className="loader" style={{ margin: "10% auto auto" }}></div>
                    </div>
                    :
                    utrList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr key={item?.report_id}>
                          <td>{index + 1}</td>
                          <td>{parsedData?.from_date}</td>
                          <td>{parsedData?.to_date}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>
                            {/* <button
                              className='btn btn-custom submitBtn'
                              
                            >
                              Download
                            </button> */}
                          </td>
                        </tr>
                      )
                    }) : null}
                {heading === 'lender' ?
                  lenderLoader ?
                    <div className='MisLoaderContainer'>
                      <div className="loader" style={{ margin: "10% auto auto" }}></div>
                    </div>
                    :
                    lenderDataList?.map((item, index) => {
                      let parsedData = JSON.parse(item?.report_request)
                      let downloadDate = getFormattedDate(new Date(item?.created_at))
                      return (
                        <tr key={item?.report_id}>
                          <td>{index + 1}</td>
                          <td>{parsedData?.assigned_date_from}</td>
                          <td>{parsedData?.assigned_date_to}</td>
                          <td>{downloadDate}</td>
                          <td>{item?.file?.file_name}</td>
                          <td>{item?.user?.full_name}</td>
                          <td>
                            <ReactTooltip id='download-document'>Download Document</ReactTooltip>
                            <i class="fa fa-cloud-download fa-lg" onClick={() => { handleReportDownload(item?.file?.file_name, item?.file?.file_id) }}
                              style={{ color: '#4A4E88', cursor: 'pointer' }} data-tip
                              data-for='download-document' ></i>
                            {/* <button
                              className='btn btn-custom submitBtn'
                              
                            >
                              Download
                            </button> */}
                          </td>
                        </tr>
                      )
                    }) : null}
              </tbody>
            </table>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  )
}
